import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue";
import _imports_0 from '../assets/arrow-right.png';
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "tasks-wrapper" };
const _hoisted_3 = ["src"];
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useContent } from '@/composables/useContent';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GuideSectionPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getPlanSection } = useContent();
        onMounted(() => {
            getCustomer();
            getPlanSection(route.params.id);
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Guide to your finances" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).planSection
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).planSection)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("h1", null, _toDisplayString(_unref(state).planSection.title), 1),
                                _createElementVNode("h2", null, _toDisplayString(_unref(state).planSection.tagLine), 1),
                                _createElementVNode("p", null, _toDisplayString(_unref(state).planSection.description), 1),
                                _createElementVNode("div", _hoisted_2, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).planSection.tasks, (task) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: task.id,
                                            class: "task-wrapper"
                                        }, [
                                            _createVNode(_component_v_row, {
                                                class: "task-row",
                                                onClick: ($event) => (_unref(router).push('/Guides/Sections/Tasks/' + task.id))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { class: "v-col-1 dot-col" }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("img", {
                                                                src: task.completed ? require('@/assets/green-dot.png') : require('@/assets/orange-dot.png')
                                                            }, null, 8, _hoisted_3)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_row, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_col, { class: "titleCol" }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(task.title), 1),
                                                                            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                                                                            _createElementVNode("span", null, _toDisplayString(task.completed ? 'Completed' : 'Not completed'), 1)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1024)
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, { class: "v-col-1 arrow-col" }, {
                                                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                            _createElementVNode("img", {
                                                                class: "arrow",
                                                                src: _imports_0
                                                            }, null, -1)
                                                        ])),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 2
                                            }, 1032, ["onClick"])
                                        ]));
                                    }), 128))
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
